import { render } from "./WorkingGroups.vue?vue&type=template&id=7b690e1e&scoped=true"
import script from "./WorkingGroups.vue?vue&type=script&lang=js"
export * from "./WorkingGroups.vue?vue&type=script&lang=js"

import "./WorkingGroups.vue?vue&type=style&index=0&id=7b690e1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b690e1e"]])

export default __exports__